module.exports = __webpack_public_path__ + "static/storage-c339faa9857a186103e5e4e1d5957755.jpg";